<template>
  <header>
      <h1>{{ title }} </h1>
  </header>
</template>

<script>

export default {
  name: "Header",
  data() {
      return {
          title:'Classifier Web-UI'
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    header{
        margin: 10px 25px 50px 25px;
        background:#222;
        padding: 6px;
    }
    h1{
        color:lightgreen;
        text-align: center;
    }
</style>
